// router push problem isn't a big deal. These errors are suppressed when using nuxt-links so we can pretty much ignore them here too.
// https://stackoverflow.com/a/65326844

export default ({ app }, inject) => {
    inject('push', {
        async to(destObj) {
            // We do not care if a link pushes to the same page.
            await app.router.push(destObj).catch(() => {})
        },
        async replace(destObj) {
            // We do not care if a link pushes to the same page.
            await app.router.replace(destObj).catch(() => {})
        },
    })
}
